import {
  MENTOR_LIST_SUCCESS,
  MENTOR_INFO_SUCCESS,
  MENTOR_CREATE_SUCCESS,
  MENTOR_UPDATE_SUCCESS,
  MENTOR_DELETE_SUCCESS,
  MENTOR_STATUS_UPDATE_SUCCESS,
  CLEAR_MENTOR_INFO,
} from "../actionTypes/mentors";
import {
  ON_SHOW_MESSAGE,
  INIT_URL,
  ON_SHOW_LOADER,
} from "../actionTypes/common";
import { userSignOut } from "./auth";
import axiosHttp from "../services/axiosCommon";

export const getMentorList = (queryInfo = {}) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.get("/v1/admin/mentors", { params: queryInfo });
    const { data } = result;
    if (!data.status && data.code !== 200) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
    } else {
      dispatch({ type: INIT_URL, payload: "/mentor/list" });
      dispatch({
        type: MENTOR_LIST_SUCCESS,
        payload: {
          data: data.results?.data || data.results || [],
          queryInfo,
          count: data.results?.count || 0,
          pages: data.results?.pages || 0,
        },
      });
    }
    return Promise.resolve(data);
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Failed to fetch mentor list",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const setMentorInfo = (info) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  dispatch({ type: MENTOR_INFO_SUCCESS, payload: info });
};

export const clearMentorInfo = () => async (dispatch) => {
  dispatch({ type: CLEAR_MENTOR_INFO });
};

export const createMentor = (infoData) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.post("/v1/admin/mentors", infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Mentor created successfully!",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: MENTOR_CREATE_SUCCESS,
        payload: data.results,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Failed to create mentor",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const updateMentor = (id, infoData) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.put(`/v1/admin/mentors/${id}`, infoData);
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Mentor updated successfully!",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: MENTOR_UPDATE_SUCCESS,
        payload: data.results,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Failed to update mentor",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const patchMentorStatus = (id, status) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.patch(`/v1/admin/mentors/${id}/status`, { status });
    const { data } = result;
    if (!data.status) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: `Mentor status updated to ${status}!`,
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: MENTOR_STATUS_UPDATE_SUCCESS,
        payload: data.results,
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Failed to update mentor status",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};

export const deleteMentor = (id) => async (dispatch) => {
  dispatch({ type: ON_SHOW_LOADER });
  try {
    const result = await axiosHttp.delete(`/v1/admin/mentors/${id}`);
    const { data } = result;
    if (data.error) {
      dispatch({ type: ON_SHOW_MESSAGE, payload: data });
      return Promise.reject(data);
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: "Mentor deleted successfully",
          status: 200,
          error: false,
        },
      });
      dispatch({
        type: MENTOR_DELETE_SUCCESS,
        payload: { id },
      });
      return Promise.resolve(data);
    }
  } catch (err) {
    const { response } = err;
    if (response && response.status === 401) {
      dispatch(
        userSignOut({
          changeMessage: true,
          payload: {
            userMessage: response.data?.message || "Unauthorized",
            status: response.status,
            error: true,
          },
        })
      );
    } else {
      dispatch({
        type: ON_SHOW_MESSAGE,
        payload: {
          userMessage: response?.data?.message || "Failed to delete mentor",
          status: response?.status || 500,
          error: true,
        },
      });
    }
    return Promise.reject(err);
  }
};
